import { useReducer } from 'react'
import effects from 'app/effects/effects'
import moment from 'moment'
import { head, isNil } from 'ramda'
import { useGroups } from 'commons/useGroups'

const actionTypoe = {
  START_FETCH: 'START_FETCH',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_ERROR: 'FETCH_ERROR',
  ON_SELECT_SUB_GROUP: 'ON_SELECT_SUB_GROUP',
}

const initialState = {
  group: {},
  isLoading: false,
  error: undefined,
  updateAt: undefined,
  subGroupSelected: undefined,
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypoe.START_FETCH:
      return {
        ...state,
        isLoading: true,
        updateAt: moment().format(),
      }

    case actionTypoe.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        group: action.payload,
        subGroupSelected: isNil(state.subGroupSelected)
          ? head(action.payload.tags)
          : state.subGroupSelected,
        updateAt: moment().format(),
      }
    case actionTypoe.UPDATE_ONLY_GROUP_DETAIL:
      return {
        ...state,
        isLoading: false,
        group: action.payload,
      }

    case actionTypoe.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        group: {},
        subGroupSelected: undefined,
        error: action.payload,
        updateAt: moment().format(),
      }
    case actionTypoe.ON_SELECT_SUB_GROUP:
      return {
        ...state,
        subGroupSelected: action.payload,
      }

    default:
      return state
  }
}

export default function useGroupDetail() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { fetchAllGroups } = useGroups()

  const handleGetGroupDetail = async (params) => {
    return await effects.apis.groupDetailV4({
      groupId: params.groupId,
    })
  }

  const getGroupDetail = async (params) => {
    try {
      dispatch({ type: actionTypoe.START_FETCH })
      const respone = await handleGetGroupDetail(params)
      dispatch({ type: actionTypoe.FETCH_SUCCESS, payload: respone })
    } catch (error) {
      dispatch({ type: actionTypoe.FETCH_ERROR, payload: error })
    }
  }

  const reFetchGroupDetail = async (params) => {
    try {
      dispatch({ type: actionTypoe.START_FETCH })
      const respone = await handleGetGroupDetail(params)
      dispatch({ type: actionTypoe.UPDATE_ONLY_GROUP_DETAIL, payload: respone })
      await fetchAllGroups()
    } catch (error) {
      dispatch({ type: actionTypoe.FETCH_ERROR, payload: error })
    }
  }

  const onSelectSubgroup = (tag) => {
    dispatch({ type: actionTypoe.ON_SELECT_SUB_GROUP, payload: tag })
  }

  return {
    state,
    getGroupDetail,
    onSelectSubgroup,
    reFetchGroupDetail,
  }
}
